export default "__VITE_ASSET__DndIdTnC__"